import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable({
  providedIn: 'root'
})
export class OnlineyogaService {

  constructor(private http: HttpClient, public router: Router, private globals: GlobalService) { }

  GetAllYogaMaster(YogaBatchID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'OnlineYoga/GetAllYogaMaster?YogaBatchID=' + YogaBatchID,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  GetYogaBookingHistory(OnlinePatientRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'OnlineYoga/GetYogaBookingHistory?OnlinePatientRegistrationID=' + OnlinePatientRegistrationID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // This function saves Yoga Booking
  SaveYogaBooking(BookingPayment) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'OnlineYoga/SaveYogaBooking', BookingPayment,
      { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
}
